import request from "@/utils/http/requset";

function amtRate(data) {
  return request({
    url: "/manage/merchant/payin/amt/rate",
    method: "post",
    ContentType: "application/json;charset=UTF-8",
    data: data
  });
}

export default {
  amtRate,
};
